import React, { useMemo, useEffect, useState } from 'react';
import api from '../api';
import { PREDEFINED_VENUES } from '../constants/campusVenues';

export default function Venues() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get('/events/occupancy')
      .then((r) => setRows(r.data.events || []))
      .finally(() => setLoading(false));
  }, []);

  const byVenue = useMemo(() => {
    const m = {};
    PREDEFINED_VENUES.forEach((v) => {
      m[v] = [];
    });
    rows.forEach((ev) => {
      const v = ev.venue;
      if (!m[v]) m[v] = [];
      m[v].push(ev);
    });
    Object.keys(m).forEach((k) => {
      m[k].sort((a, b) => new Date(a.date) - new Date(b.date));
    });
    return m;
  }, [rows]);

  return (
    <div className="page-shell">
      <div className="page-header">
        <div>
          <div className="page-title">Venues</div>
          <div className="page-subtitle">Campus venues and scheduled events across the institute</div>
        </div>
      </div>
      <div className="page-body">
        {loading ? (
          <div className="page-loading">
            <div className="spinner" />
          </div>
        ) : (
          <div className="events-grid">
            {PREDEFINED_VENUES.map((venueName) => {
              const events = byVenue[venueName] || [];
              return (
                <div key={venueName} className="card">
                  <h2 className="card-heading">{venueName}</h2>
                  {events.length === 0 ? (
                    <p style={{ color: 'var(--text-3)', fontSize: 'var(--text-sm)', marginTop: 8 }}>No events listed yet for this venue.</p>
                  ) : (
                    <div className="stack-gap" style={{ marginTop: 12 }}>
                      {events.map((ev) => (
                        <div key={ev._id} className="section-card" style={{ padding: '0.875rem 1rem', background: 'var(--gray-50)' }}>
                          <div style={{ fontWeight: 800, fontSize: 'var(--text-sm)', color: 'var(--text-1)' }}>{ev.title}</div>
                          <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-3)', marginTop: 6 }}>
                            {new Date(ev.date).toLocaleDateString('en-IN', { dateStyle: 'full' })} · {ev.status}
                          </div>
                          <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-3)', marginTop: 4 }}>
                            Host: {ev.faculty?.name || '—'} · Passes {ev.passCount ?? 0}/{ev.maxGuests} · Arrived {ev.arrivedCount ?? 0}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <p style={{ marginTop: '1.25rem', fontSize: 'var(--text-sm)', color: 'var(--text-3)', maxWidth: '40rem' }}>
          When you create an event, pick a venue here or choose &quot;Other&quot; to type a custom room. The event form shows if the same venue is already booked on the date you pick.
        </p>
      </div>
    </div>
  );
}
